import React, { useContext, useEffect, useState } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import Slider from 'react-slick';
import axios from 'axios';
import { getBaseUrl } from "../utils";
import { useNavigate } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from './UserContext';

const Dashboard = () => {
  const baseUrl = getBaseUrl();
  const [latestBlog, setLatestBlog] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [latestTest, setLatestTest] = useState([]);
  const [bannerData, setBannerWeb] = useState([]);
  const [resumes, setResumes] = useState([]);
  const token = localStorage.getItem("userToken");
  const [givenTests, setGivenTests] = useState([]);
  const [latestTests, setLatestTests] = useState([]);
  const { profileData, subscription } = useContext(UserContext);
  console.log('Dashboard Subscription ====> ', subscription);

  const checkTestAccess = () => {
    if (!subscription?.features?.test_enabled) {
      return { allowed: false, message: "Your plan does not allow tests." };
    }

    const allowedLimit = subscription.features.test || 0;
    const usedTests = givenTests.length;

    if (usedTests >= allowedLimit) {
      return {
        allowed: false,
        message: `You have reached your limit of ${allowedLimit} tests. Upgrade your plan.`
      };
    }

    return { allowed: true };
  };

  useEffect(() => {
    const fetchTestData = async () => {
      const apiUrl = baseUrl + "user_api/userHomeDataWeb";

      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data && response.data.status) {
          const data = response.data;

          setBannerWeb(data.bannerWeb || []);
          setLatestBlog(data.latestBlog || []);
          setTestimonials(data.testimonls || []);
          setLatestTest(data.latestTest || []);
        }
      } catch (error) {
        console.error("Error fetching test data:", error);
      }
    };

    fetchTestData();
    fetchResumes();
    fetchTestData_result(true, 2);
    fetchTestData_result(false, 2);

  }, [token]);


  const fetchResumes = async () => {
    try {
      const response = await axios.get(`${baseUrl}user_api/listProfile?limit=10&page=1`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (response.data.status) {
        setResumes(response.data.data[0]);
      }
    } catch (error) {
      console.error("Error fetching resumes:", error);
    }
  };
  function editResume(data) {
    if (data._id) {
      navigate(`/resume/resume-create?userProfileId=${data._id}`);
    }
  }
  function viewResume(data) {
    if (data.filePath) {
      window.open(data.filePath, "_blank");
    } else {
      toast.error("Failed to View resume.");
    }
  }

  const fetchTestData_result = async (isSubmitted, limit) => {
    const token = localStorage.getItem("userToken");
    const apiUrl = `${baseUrl}user_api/testList?isSubmitted=${isSubmitted}${limit ? `&limit=${limit}` : ""}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data && response.data.results) {
        if (isSubmitted) {
          setGivenTests(response.data.results);
        } else {
          setLatestTests(response.data.results);
        }
      }
    } catch (error) {
      console.error("Error fetching test data:", error);
    }
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % latestBlog.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + latestBlog.length) % latestBlog.length);
  };
  const navigate = useNavigate();

  const handleAttemptClick_submit = (test) => {
    const access = checkTestAccess();

    if (!access.allowed) {
      // toast.error(access.message); // better UX than alert
      navigate("/dashboard/subscription");
      return;
    }

    navigate(`/QuizForm?testId=${test._id}`);
  };

  const handleblog_submit = (blogData) => {
    navigate('/BlogDeatils', { state: { blogData: blogData } });
  };
  const limitWords = (text, wordLimit) => {
    const words = text.split(' ');
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(' ') + '...';
    }
    return text;
  };
  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false
  };
  const items = bannerData.map((banner, index) => (
    <div key={index} className="h-full w-full flex items-center justify-center">
      <a href={banner.link}>
        <img
          src={banner.img}
          alt={`Banner ${index + 1}`}
          className="w-full h-full object-cover rounded-lg"
        />
      </a>
    </div>
  ));

  const [testResult, setTestResult] = useState(null);

  const [showResultModal, setShowResultModal] = useState(false);

  const handleResultModalClose = () => {
    setShowResultModal(false);
  };

  const handleCheckResultClick = async (test) => {
    try {
      const token = localStorage.getItem("userToken");
      const response = await axios.get(`${baseUrl}user_api/testResult?test_submit_Id=${test.submissionDetails._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTestResult(response.data.results[0]);
      setShowResultModal(true);
    } catch (error) {
      console.error("Error fetching test result:", error);
    }
  };

  const subjects = testResult ? testResult.subjectsArray.map(subject => subject.name) : []; // Extract subject names for labels
  const scores = testResult ? testResult.subjectsArray.map(subject => subject.isWritingCount) : []; // Extract isWritingCount for scores

  const data = {
    labels: subjects, // Subject names as labels
    datasets: [{
      label: 'Writing Count',
      data: scores, // Writing counts as data points
      backgroundColor: 'rgba(255, 193, 7, 0.8)',
      borderColor: 'rgba(255, 193, 7, 1)',
      borderWidth: 1,
    }],
  };

  const updatedTestResult = testResult
    ? {
      ...testResult,
      needCounselling: (testResult.resultMark / testResult.fullMark) * 100 <= 50
    }
    : null;

  const dashboardClassTitle = profileData?.classDetails?.name || '';

  return (
    <div>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-6 md:block hidden'>
            <div className="h-[150px] bg-black Slider___section__main rounded-lg flex items-center justify-center">
              <AliceCarousel
                  autoPlay
                  autoPlayInterval={2000}
                  controlsStrategy="none"
                  disableDotsControls   // ✅ correct prop
                  disableButtonsControls // (optional) hide prev/next buttons
              >
                {items}
              </AliceCarousel>
            </div>
          </div>

          <div className='col-md-6 Dashboard___section__new bg-[#28282B] rounded-lg flex items-center'>
            <div className='flex p-3 items-center'>
              <div>
                <h1 className='text-white font-[700] Header__text' style={{ fontSize: '22px' }}>{dashboardClassTitle}</h1>
                <p className='text-white pt-2 Paragraph__etxt'>Unlock Your Future: A comprehensive aptitude test to guide students in choosing their ideal career stream</p>

              </div>
              <div>
                <img src='/assates/book__deshboard.png' />
              </div>
            </div>
          </div>

          <div className='col-lg-6 Dashboard___section__new pt-[30px]'>
            <div className='p-3 choose_qulifation_section bg-white rounded-lg'>

              <h1 className='Header__text font-[700] pb-3 pt-2' style={{ fontSize: '18px' }}>
                Latest Tests
              </h1>

              {/* Scrollable container */}
              <div className='max-h-[400px] overflow-y-auto pr-1'>
                {latestTests.map((testData, index) => {
                  const allowedLimit = subscription?.features?.test || 0;
                  const usedTests = givenTests.length;
                  const canAttempt = usedTests < allowedLimit;

                  return (
                      <div
                          key={index}
                          className='flex flex-col md:flex-row items-start md:items-center justify-between gap-3 border p-3 rounded-lg mb-3'
                      >

                        {/* LEFT SIDE */}
                        <div className='flex gap-3 w-full'>

                          {/* Image */}
                          <img
                              className='w-[80px] h-[80px] object-cover rounded-md'
                              src={
                                  testData.image || "https://www.mrguru.in/assates/Logo__newimage-removebg-preview.png"
                              }
                              alt='test'
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://www.mrguru.in/assates/Logo__newimage-removebg-preview.png";
                              }}
                          />
                          {/* Content */}
                          <div className='flex flex-col justify-between w-full'>
                            <div>
                              <h3 className='Header__text font-[700]' style={{ fontSize: '16px' }}>
                                {testData.name}
                              </h3>

                              <p className='Paragraph__etxt font-[600]' style={{ fontSize: '13px' }}>
                                {testData.description}
                              </p>
                            </div>

                            {/* Meta Info */}
                            <div className='flex gap-4 mt-2'>
                              <div className='flex items-center gap-1 text-sm'>
                                <img src='/assates/survey-fill.png' className='w-4' />
                                <span>{testData.totalQuestion} Questions</span>
                              </div>

                              <div className='flex items-center gap-1 text-sm'>
                                <img src='/assates/time-fill.png' className='w-4' />
                                <span>{testData.duration} Min</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* RIGHT SIDE BUTTON */}
                        <div className='w-full md:w-auto flex justify-end'>
                          <button
                              className={`px-3 py-1 rounded-lg text-white whitespace-nowrap ${
                                  !canAttempt
                                      ? 'bg-black cursor-not-allowed'
                                      : 'bg-[#28282B]'
                              }`}
                              onClick={() => handleAttemptClick_submit(testData)}
                          >
                            {canAttempt ? 'Attempt' : 'Upgrade Plan'}
                          </button>
                        </div>
                      </div>
                  );
                })}
              </div>
            </div>
          </div>


          <div className='col-lg-3 Dashboard___section__new pt-[30px] pl-0 pr-0 rounded-lg'>
            <div className='bg-white choose_qulifation_section p-2 rounded-lg'>
              <h1 className='Header__text font-[700] pb-3 pt-2' style={{ fontSize: '17px' }}>My Resume</h1>

              <div className='rounded-lg'>
                {resumes && Object.keys(resumes).length > 0 ? (
                  <div className='border p-2 rounded-lg'>
                    <img src={resumes.profile_img || ""} alt='images' className='rounded-xl h-[90px] ' />
                    <label className='Header__text font-[700] pt-3' style={{ fontSize: '16px' }}>{resumes.name || ""}</label>
                    <div className='flex items-center gap-2 mt-1'>
                      <img src='/assates/call.svg' alt='call' />
                      <label className='text-[12px] font-medium'>+91 {resumes.number || ""}</label>
                    </div>
                    <div className='flex items-center gap-2 mt-2'>
                      <i className="ri-mail-fill"></i>
                      <label className='text-[12px] font-medium'>{resumes.email || ""}</label>
                    </div>
                    <div className='flex justify-between pt-2'>
                      <div className='flex items-center gap-1 text-[#AAC000] cursor-pointer' onClick={() => editResume(resumes)}>
                        <i className="ri-pencil-line"></i>
                        <label className='text-[12px] cursor-pointer font-medium'>Edit</label>
                      </div>
                      <div className='text-[700] text-[12px] cursor-pointer font-medium' onClick={() => viewResume(resumes)}>
                        View Resume
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='border p-2 rounded-lg text-center text-gray-500'>
                    No Resume
                  </div>
                )}
              </div>
            </div>
          </div>


          <div className="col-lg-3 Dashboard___section__new pt-[30px] md:pl-2 md:pr-2 rounded-lg">
            <div className="bg-white choose_qulifation_section p-3 rounded-lg">
              <h1 className="Header__text font-[700] pb-3 pt-2" style={{ fontSize: '17px' }}>
                Testimonials
              </h1>

              <Slider {...settings}>
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="rounded-lg">
                    <div>
                      <div className="flex items-center gap-2">
                        <div>
                        <img
  src={testimonial.img || "/assates/default-user.png"}
  alt={`testimonial-${index}`}
  className="w-14 h-14 rounded-full object-cover border-2 border-gray-200 shadow-sm flex-shrink-0"
/>
                        </div>
                        <div>
                          <div className="flex gap-2">
                            {Array.from({ length: 5 }, (_, i) => (
                              <i
                                key={i}
                                className={`${i < testimonial.rate
                                    ? "ri-star-fill text-orange-500"
                                    : "ri-star-fill text-gray-500"
                                  } text-[12px]`}
                              ></i>
                            ))}
                          </div>
                          <label className="Paragraph__etxt font-[500] text-[11px]">{testimonial.user_name}</label>
                          {/* <label className="Paragraph__etxt font-[500]">{testimonial.qualification}</label> */}
                        </div>
                      </div>

                      <div className="pt-3">
                        <div className="border-b mt-1" />
                        <p className="Paragraph__etxt pt-2 text-[12px]">
                          {/* {testimonial.feedback} */}
                          {limitWords(testimonial.feedback, 20)}

                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>


          <div className='col-lg-6 Dashboard___section__new mt-4 md:mt-0'>
            <div className='bg-white choose_qulifation_section p-3 rounded-lg'>

              <h1 className='Header__text font-[700] pb-3 pt-2' style={{ fontSize: '18px' }}>
                Results
              </h1>

              {/* ✅ SINGLE SCROLL CONTAINER */}
              <div className="overflow-x-auto scrollbar-hide">
                <div className="min-w-[600px]">

                  {/* Header */}
                  <div
                    className="Paragraph__etxt font-[700] flex justify-between p-3 rounded-tr-xl rounded-tl-xl"
                    style={{ fontSize: '17px' }}
                  >
                    <div className="w-full">Name</div>
                    <div className="w-full">Date</div>
                    <div className="w-full flex justify-center">Tot. Mks</div>
                    <div className="w-full flex justify-center">Mks. Obt</div>
                    <div className="w-full flex justify-center">Action</div>
                  </div>

                  {/* Body */}
                  {givenTests && givenTests.length > 0 ? (
                    givenTests.map((testData, index) => (
                      <div className="flex justify-between p-3 border-t" key={index}>
                        <div className="w-full">{testData.name}</div>
                        <div className="w-full">{testData.submissionDetails.Created_date}</div>
                        <div className="w-full flex justify-center">
                          {testData.submissionDetails.fullMark}
                        </div>
                        <div className="w-full flex justify-center">
                          {testData.submissionDetails.resultMark}
                        </div>
                        <div className="w-full flex justify-center">
                          <button
                            className="btn text-[#0053C0] flex gap-2 items-center"
                            onClick={() => handleCheckResultClick(testData)}
                          >
                            <i className="ri-eye-line"></i>
                            <label>Result</label>
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center p-4 text-gray-500">
                      No data available
                    </div>
                  )}

                </div>
              </div>

            </div>
          </div>

          <div className='col-lg-6 Dashboard___section__new mt-4 md:mt-0 mt-4'>
            <div className='bg-white choose_qulifation_section p-3 rounded-lg'>
              <div className='flex items-center justify-between'>
                <div><h1 className='Header__text font-[700] pb-3 pt-2' style={{ fontSize: '18px' }}>Recent Blogs</h1></div>
                <div className="flex justify-between pb-2">
                  <button onClick={prevSlide} className='text-[20px] cursor-pointer'><i class="ri-arrow-right-line"></i></button>
                  <button onClick={nextSlide} className='text-[20px] cursor-pointer'><i class="ri-arrow-left-line"></i></button>
                </div>
              </div>
              <div className="flex gap-2">
                <div className="w-[40%]" onClick={() => handleblog_submit(latestBlog[currentIndex])}>
                  <img src={latestBlog[currentIndex] ? latestBlog[currentIndex].image : ''} alt="slider" className="w-[100%] rounded-lg h-[170px]" />
                </div>
                <div className="w-[60%]">
                  <h4 className="Header__text font-[700] my-2" style={{ fontSize: '16px' }}>
                    {latestBlog[currentIndex] ? latestBlog[currentIndex].name : ""}
                  </h4>
                  <div className='text-[13px] multi-truncate'
                    dangerouslySetInnerHTML={{
                      __html: latestBlog[currentIndex] ? latestBlog[currentIndex].description.slice(0, 250) + "..." : "",
                    }}
                  />

                </div>

              </div>
            </div>
          </div>

          {showResultModal && testResult && (
            <div className="modal-overlay">
              <div className="modal-container__new">
                <div className='header bg-black rounded-tl-lg rounded-tr-lg text-white p-3 relative '>
                  <h2 className='text-center font-bold Header__text'>Result</h2>
                  <i className="ri-close-circle-line absolute top-4 text-[17px] right-3" onClick={handleResultModalClose}></i>
                </div>

                <div className="modal-content p-2 Paragraph__etxt">
                  <div className='border-b p-2 flex justify-between'>
                    <label>Test Name</label>
                    <label><b>{testResult.testInfo.name}</b></label>
                  </div>

                  <div className='border-b p-2 flex justify-between'>
                    <label>Date of Given</label>
                    <label><b>{testResult.Created_date}</b></label>
                  </div>


                  <div className='border-b p-2 flex justify-between'>
                    <label>Total Marks</label>
                    <label><b>{testResult.fullMark}</b></label>
                  </div>


                  <div className='border-b p-2 flex justify-between'>

                    <label>Marks Obtained</label>
                    <label><b>{testResult.resultMark}</b></label>
                  </div>

                  <div className='border-b p-2 flex justify-between'>
                    <label>Right Attempts</label>
                    <label><b>{testResult.correctCount}</b></label>
                  </div>

                  <div className='border-b p-2 flex justify-between'>
                    <label>Wrong Attempts</label>
                    <label><b>{testResult.wrongCount}</b></label>
                  </div>

                  <div className='border-b p-2 flex justify-between'>
                    <label>Not Attempts</label>
                    <label><b>{testResult.notAttempted}</b></label>
                  </div>

                  <div className='border-b p-2 flex justify-between'>
                    <label>Need Counselling</label>
                    <label><b>{updatedTestResult.needCounselling ? 'Yes' : 'No'}</b></label>
                  </div>
                  <div className="mt-4">
                    <Bar
                      data={data}
                      options={{
                        responsive: true,
                        scales: {
                          y: {
                            beginAtZero: true,
                          },
                        },
                      }}
                    />
                  </div>


                  <div className="flex justify-between mt-4 gap-8">
                    <button
                      className="flex items-center justify-center gap-2 px-4 py-2 border border-black rounded-full text-black"
                      onClick={() => window.open(testResult.filePath, "_blank")}
                    >
                      <i className="ri-download-line"></i> Download PDF
                    </button>


                    {updatedTestResult.needCounselling && (
                      <button
                        className="px-6 py-2 bg-black text-white rounded-full"
                        onClick={() => navigate("/dashboard/counselling")}
                      >
                        Schedule Call with Consultant
                      </button>
                    )}
                  </div>

                  <div>

                  </div>

                </div>
              </div>

            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default Dashboard;
